export default __webpack_public_path__ + "static/media/DrumFailSound.808ebd13.mp3";